module.exports = __webpack_public_path__ + "img/android-icon.124030b8.svg";